// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"70":"dc8588ae","256":"45a8161e","392":"48c8ba5c","532":"7a5b68b3","572":"bbdf54e8","761":"1c32b460","838":"9f4c80b1","948":"bdcd74ee","960":"4ffe33a8"}[chunkId] + ".chunk.js";
};